<template>
  <v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>

            <v-row>
                <v-col md="12" lg="12" cols="12">
                  <v-card color="#393E46">
                    <v-card-title>Fiesta a Marcar</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col md="3" lg="3" cols="12">
                          <v-autocomplete
                              v-model="idfiesta"
                              :items="fiestas"
                              item-text="nombre"
                              item-value="id"
                              label="Escoge Fiesta"
                              persistent-hint
                              single-line
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
            </v-row>
            <v-row >
              <v-col md="12" lg="12" cols="12">
                <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
              >
              Su Invitado se borro con éxito.
               </v-alert>
                <v-data-table
                :headers="headers"
                :items="listas"
                class="elevation-1"
                sort-by="id"
                sort-desc
                :search="search"
                loading-text="Cargando... Por favor espere"

                style="background-color: #393E46;"
               >
                  <template v-slot:top>
              <v-toolbar
                  flat
              >
                <v-toolbar-title>Lista</v-toolbar-title>
                <v-progress-circular
              indeterminate
              v-if="progr == true"
              color="primary"
            ></v-progress-circular>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialogdelete" persistent max-width="350">
              <v-card>
                <v-card-title class="headline">Desea eliminar esta persona de la Fiesta?</v-card-title>
                <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="close">No</v-btn>
                  <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
              </v-toolbar>
            </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-switch v-model="item.ingreso" label="Ingreso" @click="marcar(item)" ></v-switch>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="damelistas">Cargar de Nuevo</v-btn>
                  </template>
                </v-data-table>
            </v-col>
          </v-row>
        <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
       </v-container>
    </v-main>

  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {

  title: 'Marcar Listas | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu,
  },
    data: () => ({
      overlay: false,
      idnegocio: '',
      negocio: { negocioId: '1', negocio: 'Gotica', clienteId: '1', Activo: false, Icono:'https://tunay.app/imagenes/negocios/b2ac86e6f0e58dfc24238ded27e1dc89e86a64c4.jpg',Logo:'https://tunay.app/imagenes/negocios/bcd1019c2336540d12cd0d68fcde7ce7fb43c7e0.jpg', impuesto:'0',idMoneda:'0',paisId:'173',tag:'gotica',latitud:'-12.1325729',longitud:'-77.0324181',horaApertura:'22:00:00', horaCierre:'00:00:00', tipoNegocioId:'2',Direccion:'',mailreserva:'',facebook:'',instagram:'',Ciudad:'Lima', Distrito:'Miraflores',temporadaactivaId:0,temporadaactivaNombre:''},
      idfiesta: 0,
      idfiestaxls:0,
      idtipolista: 0,
      fiestas:[],
      token:'',
      tiposlista: [],
      bajaremos: [],
      columns : [
                    {
                        label: "Nombre",
                        field: "nombre",
                    },
                    {
                        label: "DNI",
                        field: "dni",
                    },
                    {
                        label: "Promotor",
                        field: "promotor",
                    },
                ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      dialog: false,
      dialogdelete: false,
      menu1: false,
      listas: [],
      abreviado:'NN',
      search: '',
      editedIndex: -1,
      editedItem: {
        listaDetalleId: 0,
        listaDTO:{
          listaId:0,
          listaTitular:'',
          promotorId: 0,
          promotorNombre:'',
          promotorCabezaId:0,
          promotorCabezaNombre:'',
          negocioId:0,
          negocioNombre:'',
          fiestaId:0,
          fiestaNombre:'',
          fiestaFecha: null,
          fiestaActiva:true,
          tipoListaId:0,
          tipoListaNombre: '',
          clienteId:0,
          clienteNombre:'',
          diaId:0,
          diaNombre:''
        },
        nombre: '',
        dni: '',
        fechaIngreso: '',
        f: true,
        dateCreated: null
      },
      defaultItem: {
        listaDetalleId: 0,
        listaDTO:{
          listaId:0,
          listaTitular:'',
          promotorId: 0,
          promotorNombre:'',
          promotorCabezaId:0,
          promotorCabezaNombre:'',
          negocioId:0,
          negocioNombre:'',
          fiestaId:0,
          fiestaNombre:'',
          fiestaFecha: null,
          fiestaActiva:true,
          tipoListaId:0,
          tipoListaNombre: '',
          clienteId:0,
          clienteNombre:'',
          diaId:0,
          diaNombre:''
        },
        nombre: '',
        dni: '',
        fechaIngreso: '',
        f: true,
        dateCreated: null
    },
    headers: [
            { text: 'Acciones', value: 'action', sortable: false },
            { text: 'Nombre', align: 'left',  value: 'nombre'},
            { text: 'Promotor', value: 'promotor' },
            { text: 'Tipo de Lista', value: 'tipoLista' },
          ]
  }),
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio
    this.negocio = this.negocios.find(x=>x.tag === this.idnegocio)
    if (this.usuario.id === undefined){

      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damelistas();
              this.damefiestas();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
          }else{
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.damelistas();
      this.damefiestas();
          }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idnegocio"(value) {
          console.log(value);

           this.idnegocio =  this.$route.params.idnegocio
               this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
       if (this.usuario.id === undefined){
         this.$router.push({name: 'homepage'});
          }else{
         this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;

         this.damelistas();
         this.damefiestas();

       }
    },
  },
  methods : {
    cambia(){
      this.damelistasxls();
    },
    damefiestas(){
      this.progr = true;
      this.overlay = true
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
        axios
        .get(urlfiesta,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          this.damelistas();
        })
        .catch((error)  => {
        console.error(error);
          this.overlay = false
        });
    },
    damelistas(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('fId', this.idfiesta);
      bodyFormData.append('nTg', this.idnegocio);
      this.overlay = true
      axios
        .post('lista/fiesta/negocio',bodyFormData,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        })
        .then(response => {
            this.listas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
            if (this.listas.length>0){
          this.idfiesta = this.listas[0].actoId
            }
          this.overlay = false
        })
        .catch((error)  => {
        console.error(error);
          this.overlay = false
        });
    },
    marcar (item) {
      var bodyFormData = new FormData();
      bodyFormData.append('codigo', item.codigoUnico);
      this.overlay = true
      axios
          .post('lista/ingreso',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.listas = response.data;
            this.overlay = false
          })
          .catch((error)  => {
            console.error(error);
            this.overlay = false
          });
    },

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>
